import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cds-contact-list',
  templateUrl: './cds-contact-list.component.html',
  styleUrls: ['./cds-contact-list.component.scss']
})
export class CdsContactListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
